module.exports = __webpack_public_path__ + "static/img/18c.35f1d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18c.jpg
// module id = Onhr
// module chunks = 0